import React from 'react';

import { FeatureFlagContext } from 'components/feature-flags/index';

export const useFeatureFlags = () => React.useContext(FeatureFlagContext);

export default useFeatureFlags;
